export async function handleFiles(files, callback) {
  if (files?.length && callback) {
    await callback(files);
  }
}